Aedu.Auth.OAuthAdapter = function () {
  function OAuthAdapter(provider) {
    _.extend(this, Backbone.Events);
    this.provider = provider;
  }
  OAuthAdapter.prototype.login = function (extraData) {
    if (extraData == null) {
      extraData = {};
    }
    return this._authorize().done(function (_this) {
      return function (authResponse) {
        var url;
        url = "https://" + window.location.host + "/sessions";
        return _this._post(url, authResponse, extraData);
      };
    }(this));
  };
  OAuthAdapter.prototype.register = function (extraData) {
    if (extraData == null) {
      extraData = {};
    }
    return this._authorize().done(function (_this) {
      return function (authResponse) {
        var postData, url;
        url = "https://" + window.location.host + "/registrations";
        postData = _.extend({
          user_source: UserSource.last()
        }, extraData);
        postData["jsonified_auth_response"] = JSON.stringify(authResponse);
        return _this._post(url, authResponse, postData);
      };
    }(this));
  };
  OAuthAdapter.prototype._authorize = function () {
    this.trigger('oauth:attempt');
    return this._authorizeForProvider().fail(function (_this) {
      return function (error) {
        return _this.trigger('oauth:canceled', error);
      };
    }(this)).done(function (_this) {
      return function () {
        return _this.trigger('oauth:authorized');
      };
    }(this));
  };
  OAuthAdapter.prototype._post = function (url, authResponse, postData) {
    return $.ajax({
      type: 'POST',
      url: url,
      data: _.extend({
        provider: this.provider,
        oauth: {
          token: authResponse.access_token || authResponse.accessToken,
          expires: authResponse.expires_in || authResponse.expiresIn,
          scopes: authResponse.scope || authResponse.scopes || authResponse.grantedScopes
        }
      }, postData),
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      }
    }).done(function (_this) {
      return function (response) {
        var data, errors, ok;
        ok = response[0], data = response[1], errors = response[2];
        if (ok) {
          return _this.trigger('oauth:success', data);
        } else if (data != null ? data.email : void 0) {
          return _this.trigger('oauth:email_taken', data);
        } else {
          return _this.trigger('oauth:invalid', errors);
        }
      };
    }(this)).fail(function (_this) {
      return function () {
        return _this.trigger('oauth:error');
      };
    }(this));
  };
  OAuthAdapter.prototype._authorizeForProvider = function () {
    switch (this.provider) {
      case 'google':
        return Google.authorize();
      case 'facebook':
        return Facebook.$authorize();
    }
  };
  return OAuthAdapter;
}();